// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: T-YbPmutrf
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import StandardButton from "../../StandardButton"; // plasmic-import: wzNiXPwRag/component
import FileActions from "../../FileActions"; // plasmic-import: ItAMwN5qPyr/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "./plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicResubmissionComponent.module.css"; // plasmic-import: T-YbPmutrf/css

createPlasmicElementProxy;

export const PlasmicResubmissionComponent__VariantProps = new Array("page");

export const PlasmicResubmissionComponent__ArgProps = new Array("pricing");

const $$ = {};

function PlasmicResubmissionComponent__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "page",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.page
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootpage_completed]: hasVariant($state, "page", "completed"),
          [sty.rootpage_decision]: hasVariant($state, "page", "decision"),
          [sty.rootpage_upload]: hasVariant($state, "page", "upload")
        }
      )}
    >
      <div
        className={classNames(projectcss.all, sty.freeBox__y6UP, {
          [sty.freeBoxpage_completed__y6UPV0MK]: hasVariant(
            $state,
            "page",
            "completed"
          ),
          [sty.freeBoxpage_decision__y6UPaZKqt]: hasVariant(
            $state,
            "page",
            "decision"
          ),
          [sty.freeBoxpage_loading__y6UPFpV6F]: hasVariant(
            $state,
            "page",
            "loading"
          ),
          [sty.freeBoxpage_upload__y6UPFzEhL]: hasVariant(
            $state,
            "page",
            "upload"
          )
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__qeMip, {
            [sty.freeBoxpage_completed__qeMipv0MK]: hasVariant(
              $state,
              "page",
              "completed"
            ),
            [sty.freeBoxpage_decision__qeMiPaZKqt]: hasVariant(
              $state,
              "page",
              "decision"
            ),
            [sty.freeBoxpage_loading__qeMipFpV6F]: hasVariant(
              $state,
              "page",
              "loading"
            ),
            [sty.freeBoxpage_upload__qeMipFzEhL]: hasVariant(
              $state,
              "page",
              "upload"
            )
          })}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__beD7R,
              {
                [sty.textpage_completed__beD7RV0MK]: hasVariant(
                  $state,
                  "page",
                  "completed"
                )
              }
            )}
          >
            {"Resubmission Request"}
          </div>
          <div
            data-plasmic-name={"closeBtn"}
            data-plasmic-override={overrides.closeBtn}
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.closeBtn,
              {
                [sty.closeBtnpage_upload]: hasVariant($state, "page", "upload")
              }
            )}
          >
            {"X"}
          </div>
        </div>
        {(hasVariant($state, "page", "completed") ? true : false) ? (
          <Stack__
            as={"div"}
            data-plasmic-name={"b"}
            data-plasmic-override={overrides.b}
            hasGap={true}
            className={classNames(projectcss.all, sty.b, {
              [sty.bpage_completed]: hasVariant($state, "page", "completed")
            })}
          >
            {(hasVariant($state, "page", "completed") ? true : false) ? (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__fQeWt,
                  {
                    [sty.textpage_completed__fQeWtV0MK]: hasVariant(
                      $state,
                      "page",
                      "completed"
                    )
                  }
                )}
              >
                {hasVariant($state, "page", "completed")
                  ? "Thank you for your request.  \nWe will notify you once it is processed."
                  : "Enter some text"}
              </div>
            ) : null}
            {(hasVariant($state, "page", "completed") ? true : false) ? (
              <StandardButton
                data-plasmic-name={"bigCloseBtn"}
                data-plasmic-override={overrides.bigCloseBtn}
                className={classNames("__wab_instance", sty.bigCloseBtn, {
                  [sty.bigCloseBtnpage_completed]: hasVariant(
                    $state,
                    "page",
                    "completed"
                  )
                })}
              />
            ) : null}
          </Stack__>
        ) : null}
        {(hasVariant($state, "page", "loading") ? true : false) ? (
          <div
            className={classNames(projectcss.all, sty.freeBox__jyFiT, {
              [sty.freeBoxpage_loading__jyFiTFpV6F]: hasVariant(
                $state,
                "page",
                "loading"
              )
            })}
          >
            {(hasVariant($state, "page", "loading") ? true : false) ? (
              <div
                data-plasmic-name={"loadingArea"}
                data-plasmic-override={overrides.loadingArea}
                className={classNames(projectcss.all, sty.loadingArea, {
                  [sty.loadingAreapage_loading]: hasVariant(
                    $state,
                    "page",
                    "loading"
                  )
                })}
              >
                {(hasVariant($state, "page", "loading") ? true : false) ? (
                  <div
                    data-plasmic-name={"loadingHolder"}
                    data-plasmic-override={overrides.loadingHolder}
                    className={classNames(projectcss.all, sty.loadingHolder, {
                      [sty.loadingHolderpage_loading]: hasVariant(
                        $state,
                        "page",
                        "loading"
                      )
                    })}
                  />
                ) : null}
              </div>
            ) : null}
          </div>
        ) : null}
        {(hasVariant($state, "page", "upload") ? true : false) ? (
          <Stack__
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__dbkRp, {
              [sty.freeBoxpage_decision__dbkRpaZKqt]: hasVariant(
                $state,
                "page",
                "decision"
              ),
              [sty.freeBoxpage_upload__dbkRpFzEhL]: hasVariant(
                $state,
                "page",
                "upload"
              )
            })}
          >
            {(hasVariant($state, "page", "upload") ? true : false) ? (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__pvvY,
                  {
                    [sty.textpage_upload__pvvYFzEhL]: hasVariant(
                      $state,
                      "page",
                      "upload"
                    )
                  }
                )}
              >
                {hasVariant($state, "page", "upload")
                  ? "Please provide a reason for your request."
                  : "Enter some text"}
              </div>
            ) : null}
            {(hasVariant($state, "page", "upload") ? true : false) ? (
              <textarea
                data-plasmic-name={"commentTxt"}
                data-plasmic-override={overrides.commentTxt}
                className={classNames(
                  projectcss.all,
                  projectcss.textarea,
                  sty.commentTxt,
                  {
                    [sty.commentTxtpage_upload]: hasVariant(
                      $state,
                      "page",
                      "upload"
                    )
                  }
                )}
                placeholder={
                  hasVariant($state, "page", "upload") ? "" : undefined
                }
                ref={ref => {
                  $refs["commentTxt"] = ref;
                }}
                value={
                  hasVariant($state, "page", "upload")
                    ? ""
                    : "This is a text area."
                }
              />
            ) : null}
            {(hasVariant($state, "page", "upload") ? true : false) ? (
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__tI8A,
                  {
                    [sty.textpage_upload__tI8AFzEhL]: hasVariant(
                      $state,
                      "page",
                      "upload"
                    )
                  }
                )}
              >
                {hasVariant($state, "page", "upload")
                  ? "Please upload any supporting documentation or proof of payment."
                  : "Enter some text"}
              </div>
            ) : null}
            {(hasVariant($state, "page", "upload") ? true : false) ? (
              <div
                data-plasmic-name={"docType"}
                data-plasmic-override={overrides.docType}
                className={classNames(projectcss.all, sty.docType, {
                  [sty.docTypepage_upload]: hasVariant($state, "page", "upload")
                })}
              />
            ) : null}
            {(hasVariant($state, "page", "upload") ? true : false) ? (
              <button
                data-plasmic-name={"chooseBtn"}
                data-plasmic-override={overrides.chooseBtn}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  projectcss.__wab_text,
                  sty.chooseBtn,
                  {
                    [sty.chooseBtnpage_decision]: hasVariant(
                      $state,
                      "page",
                      "decision"
                    ),
                    [sty.chooseBtnpage_upload]: hasVariant(
                      $state,
                      "page",
                      "upload"
                    )
                  }
                )}
                ref={ref => {
                  $refs["chooseBtn"] = ref;
                }}
              >
                {hasVariant($state, "page", "upload")
                  ? "Choose Files"
                  : "Pay Now"}
              </button>
            ) : null}
            {(hasVariant($state, "page", "upload") ? true : false) ? (
              <div
                data-plasmic-name={"fileHolder"}
                data-plasmic-override={overrides.fileHolder}
                className={classNames(projectcss.all, sty.fileHolder, {
                  [sty.fileHolderpage_upload]: hasVariant(
                    $state,
                    "page",
                    "upload"
                  )
                })}
              >
                {(hasVariant($state, "page", "upload") ? true : false) ? (
                  <FileActions
                    data-plasmic-name={"fileActions"}
                    data-plasmic-override={overrides.fileActions}
                    className={classNames("__wab_instance", sty.fileActions, {
                      [sty.fileActionspage_upload]: hasVariant(
                        $state,
                        "page",
                        "upload"
                      )
                    })}
                    page={
                      hasVariant($state, "page", "upload")
                        ? "upload"
                        : undefined
                    }
                  />
                ) : null}
              </div>
            ) : null}
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__qWrGa, {
                [sty.freeBoxpage_decision__qWrGaaZKqt]: hasVariant(
                  $state,
                  "page",
                  "decision"
                ),
                [sty.freeBoxpage_upload__qWrGaFzEhL]: hasVariant(
                  $state,
                  "page",
                  "upload"
                )
              })}
            >
              {(hasVariant($state, "page", "upload") ? true : false) ? (
                <button
                  data-plasmic-name={"backBtn"}
                  data-plasmic-override={overrides.backBtn}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    projectcss.__wab_text,
                    sty.backBtn,
                    {
                      [sty.backBtnpage_upload]: hasVariant(
                        $state,
                        "page",
                        "upload"
                      )
                    }
                  )}
                  ref={ref => {
                    $refs["backBtn"] = ref;
                  }}
                >
                  {hasVariant($state, "page", "upload") ? "Back" : "Pay Now"}
                </button>
              ) : null}
              {(hasVariant($state, "page", "upload") ? true : false) ? (
                <button
                  data-plasmic-name={"sendBtn"}
                  data-plasmic-override={overrides.sendBtn}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    projectcss.__wab_text,
                    sty.sendBtn,
                    {
                      [sty.sendBtnpage_upload]: hasVariant(
                        $state,
                        "page",
                        "upload"
                      )
                    }
                  )}
                  ref={ref => {
                    $refs["sendBtn"] = ref;
                  }}
                >
                  {hasVariant($state, "page", "upload")
                    ? "Send Request"
                    : "Pay Now"}
                </button>
              ) : null}
            </Stack__>
          </Stack__>
        ) : null}
        {(
          hasVariant($state, "page", "completed")
            ? false
            : hasVariant($state, "page", "loading")
            ? false
            : hasVariant($state, "page", "upload")
            ? false
            : true
        ) ? (
          <div
            data-plasmic-name={"pricingTxt"}
            data-plasmic-override={overrides.pricingTxt}
            className={classNames(projectcss.all, sty.pricingTxt, {
              [sty.pricingTxtpage_completed]: hasVariant(
                $state,
                "page",
                "completed"
              ),
              [sty.pricingTxtpage_decision]: hasVariant(
                $state,
                "page",
                "decision"
              ),
              [sty.pricingTxtpage_loading]: hasVariant(
                $state,
                "page",
                "loading"
              ),
              [sty.pricingTxtpage_upload]: hasVariant($state, "page", "upload")
            })}
          >
            {renderPlasmicSlot({
              defaultContents:
                "The cost of a resubmission request for this rollout is R50.00. If you would like to pay electronically click Pay Now. Alternatively, you can submit a request for consideration.",
              value: args.pricing
            })}
          </div>
        ) : null}
        {(hasVariant($state, "page", "decision") ? false : false) ? (
          <Stack__
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__epKd3, {
              [sty.freeBoxpage_decision__epKd3AZKqt]: hasVariant(
                $state,
                "page",
                "decision"
              )
            })}
          >
            {(hasVariant($state, "page", "decision") ? true : false) ? (
              <StandardButton
                data-plasmic-name={"standardButton"}
                data-plasmic-override={overrides.standardButton}
                className={classNames("__wab_instance", sty.standardButton, {
                  [sty.standardButtonpage_decision]: hasVariant(
                    $state,
                    "page",
                    "decision"
                  )
                })}
              />
            ) : null}
            {(hasVariant($state, "page", "decision") ? true : false) ? (
              <StandardButton
                data-plasmic-name={"requestBtn2"}
                data-plasmic-override={overrides.requestBtn2}
                className={classNames("__wab_instance", sty.requestBtn2, {
                  [sty.requestBtn2page_decision]: hasVariant(
                    $state,
                    "page",
                    "decision"
                  )
                })}
              />
            ) : null}
          </Stack__>
        ) : null}
        {(hasVariant($state, "page", "decision") ? true : false) ? (
          <Stack__
            as={"div"}
            hasGap={true}
            className={classNames(projectcss.all, sty.freeBox__jbZ56, {
              [sty.freeBoxpage_decision__jbZ56AZKqt]: hasVariant(
                $state,
                "page",
                "decision"
              ),
              [sty.freeBoxpage_upload__jbZ56FzEhL]: hasVariant(
                $state,
                "page",
                "upload"
              )
            })}
          >
            {(hasVariant($state, "page", "upload") ? false : true) ? (
              <button
                data-plasmic-name={"payNowBtn"}
                data-plasmic-override={overrides.payNowBtn}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  projectcss.__wab_text,
                  sty.payNowBtn,
                  {
                    [sty.payNowBtnpage_decision]: hasVariant(
                      $state,
                      "page",
                      "decision"
                    ),
                    [sty.payNowBtnpage_upload]: hasVariant(
                      $state,
                      "page",
                      "upload"
                    )
                  }
                )}
                ref={ref => {
                  $refs["payNowBtn"] = ref;
                }}
              >
                {"Pay Now"}
              </button>
            ) : null}
            {(hasVariant($state, "page", "upload") ? false : true) ? (
              <button
                data-plasmic-name={"requestBtn"}
                data-plasmic-override={overrides.requestBtn}
                className={classNames(
                  projectcss.all,
                  projectcss.button,
                  projectcss.__wab_text,
                  sty.requestBtn,
                  {
                    [sty.requestBtnpage_decision]: hasVariant(
                      $state,
                      "page",
                      "decision"
                    ),
                    [sty.requestBtnpage_upload]: hasVariant(
                      $state,
                      "page",
                      "upload"
                    )
                  }
                )}
                ref={ref => {
                  $refs["requestBtn"] = ref;
                }}
              >
                {"Request"}
              </button>
            ) : null}
          </Stack__>
        ) : null}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "closeBtn",
    "b",
    "bigCloseBtn",
    "loadingArea",
    "loadingHolder",
    "commentTxt",
    "docType",
    "chooseBtn",
    "fileHolder",
    "fileActions",
    "backBtn",
    "sendBtn",
    "pricingTxt",
    "standardButton",
    "requestBtn2",
    "payNowBtn",
    "requestBtn"
  ],

  closeBtn: ["closeBtn"],
  b: ["b", "bigCloseBtn"],
  bigCloseBtn: ["bigCloseBtn"],
  loadingArea: ["loadingArea", "loadingHolder"],
  loadingHolder: ["loadingHolder"],
  commentTxt: ["commentTxt"],
  docType: ["docType"],
  chooseBtn: ["chooseBtn"],
  fileHolder: ["fileHolder", "fileActions"],
  fileActions: ["fileActions"],
  backBtn: ["backBtn"],
  sendBtn: ["sendBtn"],
  pricingTxt: ["pricingTxt"],
  standardButton: ["standardButton"],
  requestBtn2: ["requestBtn2"],
  payNowBtn: ["payNowBtn"],
  requestBtn: ["requestBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicResubmissionComponent__ArgProps,
          internalVariantPropNames: PlasmicResubmissionComponent__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicResubmissionComponent__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicResubmissionComponent";
  } else {
    func.displayName = `PlasmicResubmissionComponent.${nodeName}`;
  }
  return func;
}

export const PlasmicResubmissionComponent = Object.assign(
  // Top-level PlasmicResubmissionComponent renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    closeBtn: makeNodeComponent("closeBtn"),
    b: makeNodeComponent("b"),
    bigCloseBtn: makeNodeComponent("bigCloseBtn"),
    loadingArea: makeNodeComponent("loadingArea"),
    loadingHolder: makeNodeComponent("loadingHolder"),
    commentTxt: makeNodeComponent("commentTxt"),
    docType: makeNodeComponent("docType"),
    chooseBtn: makeNodeComponent("chooseBtn"),
    fileHolder: makeNodeComponent("fileHolder"),
    fileActions: makeNodeComponent("fileActions"),
    backBtn: makeNodeComponent("backBtn"),
    sendBtn: makeNodeComponent("sendBtn"),
    pricingTxt: makeNodeComponent("pricingTxt"),
    standardButton: makeNodeComponent("standardButton"),
    requestBtn2: makeNodeComponent("requestBtn2"),
    payNowBtn: makeNodeComponent("payNowBtn"),
    requestBtn: makeNodeComponent("requestBtn"),
    // Metadata about props expected for PlasmicResubmissionComponent
    internalVariantProps: PlasmicResubmissionComponent__VariantProps,
    internalArgProps: PlasmicResubmissionComponent__ArgProps
  }
);

export default PlasmicResubmissionComponent;
/* prettier-ignore-end */
